import * as React from "react";
import { useLocation } from "@reach/router";

import {
  FacebookShareButton,
  WhatsappShareButton,
  PinterestShareButton,
} from "react-share";
import { isBrowser } from "../../data/utils";

const ShareButtons = ({ data, positionEventLabel = "direita" }) => {
  const url = useLocation().href;

  function dataLayerShare(method) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "share",
      label: method,
      item_category: "conteudo",
    });
  }

  return (
    <div className="share-buttons eva-margin-bottom-4">
      <WhatsappShareButton
        data-track={`Nova página de conteúdo - botão de compartilhar whatsapp - ${positionEventLabel}`}
        onClick={() => {
          dataLayerShare("whatsapp");
        }}
        url={url}
        resetButtonStyle={false}
        className="eva-btn-icon eva-btn-outline eva-btn-small"
        aria-label="Compartilhar WhatsApp"
      >
        <i className="fab fa-whatsapp"></i>
      </WhatsappShareButton>
      <FacebookShareButton
        data-track={`Nova página de conteúdo - botão de compartilhar facebook - ${positionEventLabel}`}
        onClick={() => {
          dataLayerShare("facebook");
        }}
        url={url}
        resetButtonStyle={false}
        className="eva-btn-icon eva-btn-outline eva-btn-small"
        aria-label="Compartilhar Facebook"
      >
        <i className="fab fa-facebook-f"></i>
      </FacebookShareButton>
      <PinterestShareButton
        data-track={`Nova página de conteúdo - botão de compartilhar pinterest - ${positionEventLabel}`}
        onClick={() => {
          dataLayerShare("pinterest");
        }}
        url={url}
        resetButtonStyle={false}
        media={isBrowser() ? data.content.featuredImage : ""}
        description={data.content.title}
        className="eva-btn-icon eva-btn-outline eva-btn-small"
        aria-label="Compartilhar Pinterest"
      >
        <i className="fab fa-pinterest-p"></i>
      </PinterestShareButton>
    </div>
  );
};

export default ShareButtons;
